import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	signatureId: () => faker.string.uuid(),
	operationType: 'sealeBetBizum',
	operationDescription: 'Pago en apuestas con Bizum',
	creationDate: faker.date.past(2).toISOString(),
	data: {
		amount: () => parseFloat(faker.finance.amount()),
		currency: 'EUR',
		origin: () => faker.number.int(9999),
		destination: () => faker.number.int(9999),
	},
	pending: trait({ status: 'PENDING' }),
	pendingNoAmount: trait({
		status: 'PENDING',
		data: {
			currency: 'EUR',
			origin: () => faker.number.int(9999),
			destination: () => faker.number.int(9999),
		},
	}),
	signed: trait({
		status: 'SIGNED',
		signatureDate: faker.date.future(2).toISOString(),
	}),
	signedNoAmount: trait({
		status: 'SIGNED',
		signatureDate: faker.date.future(2).toISOString(),
		data: {
			currency: 'EUR',
			origin: () => faker.number.int(9999),
			destination: () => faker.number.int(9999),
		},
	}),
	canceled: trait({ status: 'CANCELED' }),
	expired: trait({ status: 'EXPIRED' }),
});
